// Deterministic color assignment per user (so colors are stable across renders/sessions)
const PALETTE = [
  { bg: "bg-sky-100", border: "border-sky-300", text: "text-sky-900", dot: "bg-sky-500", hex: "#0284c7" },
  { bg: "bg-emerald-100", border: "border-emerald-300", text: "text-emerald-900", dot: "bg-emerald-500", hex: "#059669" },
  { bg: "bg-amber-100", border: "border-amber-300", text: "text-amber-900", dot: "bg-amber-500", hex: "#d97706" },
  { bg: "bg-rose-100", border: "border-rose-300", text: "text-rose-900", dot: "bg-rose-500", hex: "#e11d48" },
  { bg: "bg-violet-100", border: "border-violet-300", text: "text-violet-900", dot: "bg-violet-500", hex: "#7c3aed" },
  { bg: "bg-teal-100", border: "border-teal-300", text: "text-teal-900", dot: "bg-teal-500", hex: "#0d9488" },
  { bg: "bg-fuchsia-100", border: "border-fuchsia-300", text: "text-fuchsia-900", dot: "bg-fuchsia-500", hex: "#c026d3" },
  { bg: "bg-lime-100", border: "border-lime-300", text: "text-lime-900", dot: "bg-lime-500", hex: "#65a30d" },
  { bg: "bg-orange-100", border: "border-orange-300", text: "text-orange-900", dot: "bg-orange-500", hex: "#ea580c" },
  { bg: "bg-cyan-100", border: "border-cyan-300", text: "text-cyan-900", dot: "bg-cyan-500", hex: "#0891b2" },
  { bg: "bg-indigo-100", border: "border-indigo-300", text: "text-indigo-900", dot: "bg-indigo-500", hex: "#4f46e5" },
  { bg: "bg-pink-100", border: "border-pink-300", text: "text-pink-900", dot: "bg-pink-500", hex: "#db2777" },
];

function hashString(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function userColor(userId) {
  if (!userId) return PALETTE[0];
  return PALETTE[hashString(String(userId)) % PALETTE.length];
}
